// BHP-1087/1088: generic VPS overview — Backend2.0 `GET /api/vps`, filtered to
// the `server-type=generic` label. Rendering lives in the shared VpsServerList.
import VpsServerList from '../../features/vps/ui/VpsServerList';

export default function VpsOverview(): JSX.Element {
  return (
    <VpsServerList
      serverType="generic"
      detailsBasePath="/vps/generic"
      noun="VPS servers"
    />
  );
}
